export enum LogLevel {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  DEBUG = 'debug',
  EVENT = 'event',
  LOG = 'log'
}

export interface TrafficSource {
  name: string; // Name of the marketing campaign that acquired the user when the events were reported.
  source: string; // Name of the medium (paid search, organic search, email, etc.) that acquired the user when the events were reported.
  medium: string; // Name of the network source that acquired the user when the event were reported.
}

export interface LoggerMessage {
  data?: string;
}

export interface EventMessage {
  id: string;
  appId: string;
  appVersion: string;
  platform: string; // (Web, IOS or Android, Android web etc)
  trafficSource?: TrafficSource;
  timestamp: Date;
  deviceId: string; // client generated id
  userId: string | undefined;
  type: string; // click or view
  data?: Record<string, any>; // event specific data
  pageUrl?: string;
  userAgent: string;
  referrer?: string | null;
  sessionId: string;
  location?: string;
}

type ExtendedMessage = LoggerMessage | EventMessage;

export type Message = ExtendedMessage & {
  message: string;
  filePath?: string;
  cookies?: string;
};

export type Log = Message & {
  level: string;
  timeStamp?: number;
  cookies?: string;
};

export interface LogBody {
  service: string;
  log: Log;
}
